//---------------------------------------------
// Formulários Module 
//---------------------------------------------
// Módulo para gerenciar as ações dos formulários

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    listFormularios: []
})

// MUTATIONS
const mutations = {
     //-- MUTATION REQUISICAO DO LISTFORMS
     setListFormularios(state, payload) {
        state.listFormularios = payload
    },
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DO LISTFORMS
    async setListFormularios({ commit }) {
        await axios
            .get(`formularios/list/AllFormularios`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListFormularios', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION REQUISICAO DO LISTFORMS BY REGIONAL
    async setListFormulariosByRegional({ commit },idRegional) {
        await axios
            .get(`formularios/regional/${idRegional}`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(response => {
                commit('setListFormularios', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    //-- ACTION DELETE FORMULARIO 
    async deleteFormulario(_, payload) {
        await axios
            .delete(`formularios/${payload.idInstituicao}/${payload.idFormulario}`, {
                idFormulario: payload.idFormulario
            },{
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                }
            })
            .then(() => {
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getListFormularios(state) {
        try {
            return state.listFormularios.data
        } catch (e) {
            return []
        }
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
